import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-commission',
  templateUrl: './commission.component.html',
  styleUrls: ['./commission.component.css']
})
export class CommissionComponent implements OnInit {

  mainColl: any = [];
  pinnedBottomRowData: any = [];
  showProgress: boolean = false;
  isview: boolean = false;
  isexport: boolean = false;
  formname: String = "CommissionReport";

  fromdate: any = new Date();
  todate: any = new Date();
  isshowfromdate: boolean = false;

  private gridApi;

  columnDefs = [
    { headerName: 'Order No', field: 'orderno', sortable: true, filter: true },
    { headerName: 'Order Date', field: 'orderdate', valueFormatter: this.fnMomentDateTimeFormatter },
    { headerName: 'Restaurant', field: 'restaurantname', sortable: true, filter: true },
    { headerName: 'Grand Total', field: 'grandtotal', valueFormatter: this.fnFormatDecimal },
    { headerName: 'Commission %', field: 'rescommisionperc', sortable: true, filter: true, cellStyle: { 'background-color': '#e6f7ff' } },
    { headerName: 'Commission Amt', field: 'rescommisionamount', sortable: true, filter: true, valueFormatter: this.fnFormatDecimal, cellStyle: { 'font-weight': 'bold' } },
    // { headerName: 'Taxable Amt', field: 'taxableamt', valueFormatter: this.fnFormatDecimal },
    // { headerName: 'Tax Amt', field: 'taxamt', valueFormatter: this.fnFormatDecimal },
    { headerName: 'Pay Mode', field: 'paymentmodename' }
  ];

  gridOptions = {
    rowSelection: 'single',
    rowHeight: 40,
    defaultColDef: { resizable: true, flex: 1, minWidth: 100, sortable: true, filter: true },
  };

  constructor(
    private appService: DhukanDataService, 
    private datePipe: DatePipe,
    private toastr: ToastrService, 
    private loginService: LoginDataService
  ) { }

  ngOnInit() {
    this.fnCheckPrivilage();
    if (this.isview) {
      this.fngetReportListView();
    }
  }

  fnCheckPrivilage() {
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fngetReportListView() {
    this.showProgress = true;
    let fromDateFormatted = this.isshowfromdate ? null : this.datePipe.transform(this.fromdate, "yyyy-MM-dd");
    
    let data = {
      'fromdate': fromDateFormatted,
      'todate': this.datePipe.transform(this.todate, "yyyy-MM-dd"),
      'formname': 'COMMISSIONREPORT',
      'modifiedby': this.loginService.fnGetModUserId(),
    };

    this.appService.getReportSalesView(data).subscribe(
      (res) => {
        this.showProgress = false;
        let response = res.json();
        if (response.status == 200) {
          this.mainColl = response.result[0];
          this.pinnedBottomRowData = response.result[1]; 
        } else {
          this.toastr.error('Error', response.err_field);
        }
      },
      (err) => {
        this.showProgress = false;
        this.toastr.error('Error', 'Server Error');
      }
    );
  }

  fnGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  fnExportData() {
    this.gridApi.exportDataAsCsv({ fileName: 'CommissionReport' });
  }

  fnFormatDecimal(params) {
    return params.value ? params.value.toFixed(2) : '0.00';
  }

  fnMomentDateTimeFormatter(params) {
    return params.value ? moment(params.value).format('DD-MM-YYYY hh:mm a') : '';
  }
}